module.exports = __webpack_public_path__ + "img/account.933f5dce.png";